import {
  EXPORT_MULTIPLE_CLIENT_REPORT_PDF,
  CLEAR_MULTIPLE_CLIENTS_REPORT_PDF
} from '../types';

import createAsyncActions from '../../../utilities/createAsyncActions';
import { createAction } from 'redux-actions';

export const {
  exportMultipleClientReportPdf,
  exportMultipleClientReportPdfPending,
  exportMultipleClientReportPdfFulfilled,
  exportMultipleClientReportPdfRejected,
} = createAsyncActions(EXPORT_MULTIPLE_CLIENT_REPORT_PDF, 'exportMultipleClientReportPdf');


export const clearMultipleClientsReportPdf = createAction(CLEAR_MULTIPLE_CLIENTS_REPORT_PDF);




// WEBPACK FOOTER //
// ./src/features/reports/actions/exportMultipleClientReportPdfActions.js